export default __webpack_public_path__ + "static/commmune_fanmarketing-1b139243161ade68f0625d6e694a49e1.jpg";